import { lazy, Suspense } from 'react';
import type { PagePulseScopeRegistrarProps } from './PagePulseScopeRegistrar';

const PagePulseScopeRegistrar = lazy(() => import('./PagePulseScopeRegistrar'));

export function PagePulseScopeRegistrarGate(props: PagePulseScopeRegistrarProps) {
  return (
    <Suspense fallback={null}>
      <PagePulseScopeRegistrar {...props} />
    </Suspense>
  );
}
